import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Hidden } from "@material-ui/core";
import MuiDrawer from "@material-ui/core/Drawer";

const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    drawer: {
      [theme.breakpoints.up("lg")]: {
        width: theme.layoutDimensions.mainDrawerWidth,
        flexShrink: 0,
      },
    },
    drawerPaper: {
      width: theme.layoutDimensions.mainDrawerWidth,
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
      borderRight: "none", // so that there is no line between the ofqual logo and app bar title
      overflow: "hidden",
      marginTop: 50,
      paddingTop: 20, 
      "& h6": {

        "font-weight": "500 !important",
        "line-height": "1.6 !important",
        "font-stretch": "condensed !important",
        "letter-spacing": "0.0075em !important",
        "font-variant-caps": "small-caps !important",
        "color": "#fff !important",
        "font-size": "1rem !important",
        "margin": "0px !important",
      }
    }, 
  })
);

type ResponsiveDrawerProps = {
  isMobileOpen: boolean;
  handleDrawerToggle: () => void;
};

export const ResponsiveDrawer: React.FC<ResponsiveDrawerProps> = ({
  children,
  isMobileOpen,
  handleDrawerToggle,
}) => {
  const classes = useStyles();

  return (
    <nav className={classes.drawer}>
      <Hidden mdUp implementation="css">
        <MuiDrawer
          variant="temporary"
          open={isMobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {children}
        </MuiDrawer>
      </Hidden>

      <Hidden mdDown implementation="css">
        <MuiDrawer
          classes={{
            paper: classes.drawerPaper,
          }}
          variant="permanent"
          // open
        >
          {children}
        </MuiDrawer> 
      </Hidden>
    </nav>
  );
};
